/**
 * Author: Wilson Pilco Nuñez
 * Email: wilsonaux1@gmail.com
 * Created at: 2026-09-03 15:39
 */

const feriados = {
  "2026-01-01": "Año Nuevo: Es el día donde empieza el año.",
  "2026-04-17": "Jueves Santo: Estas fechas corresponden a los días inmediatamente anteriores al Domingo de Resurrección.",
  "2026-04-18": "Viernes Santo: Estas fechas corresponden a los días inmediatamente anteriores al Domingo de Resurrección.",
  "2026-05-01": "Día internacional de los trabajadores: Es irrenunciable.",
  "2026-06-07": "Día de la Bandera: Es irrenunciable.",
  "2026-06-29": "San Pedro y San Pablo",
  "2026-07-23": "Día de la Fuerza Aérea: Es irrenunciable.",
  "2026-07-28": "Día de la Independencia: Es irrenunciable.",
  "2026-07-29": "Día de la Independencia: Es irrenunciable.",
  "2026-08-06": "Batalla de Junín: Es irrenunciable.",
  "2026-08-30": "Día de Santa Rosa de Lima",
  "2026-10-08": "Combate naval de Angamos",
  "2026-11-01": "Día de Todos los Santos",
  "2026-12-08": "Inmaculada Concepción de la Virgen",
  "2026-12-09": "Batalla de Ayacucho",
  "2026-12-25": "Navidad: Es irrenunciable."
};

export default feriados;
